import useApiResource from "hooks/use_api_resource"

export default ({ signupId, data, ...options }) => {
  const path = `signups/${signupId}/attendee_types`

  const { index, create, update, destroy } = useApiResource({
    path,
    data,
    ...options
  })

  return { index, create, update, destroy }
}
